import * as React from 'react';
import { LoadingIcon } from '../LoadingIcon';
import './BusyContainer.scss';

export const BusyContainer: React.SFC<IProps> = props => (
  <div className="busy-container">
    {props.isBusy && <LoadingIcon />}
    {props.isError && <div className="busy-container--error" role="alert">Sorry, something goes wrong.</div>}
    {props.children}
  </div>
);

interface IProps {
  isBusy: boolean;
  isError: boolean;
}



// WEBPACK FOOTER //
// ./src/components/BusyContainer/BusyContainer.tsx